var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-overlay',[_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":64}}),_c('v-spacer',{staticClass:"pa-3"}),_c('span',[_vm._v(" "+_vm._s(_vm.$t('ui.loading'))+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }